// extracted by mini-css-extract-plugin
export default {"root":"_31v2e_-j","pane":"_3kogH2CO","products":"_2OMwWxnQ","messengers":"_2H0GXi2n","sectionHeading":"b6TQL0Qx","buttons":"_10pWsvHs","paymentButtons":"_36syB53y"};